import { override } from "flarum/extend";
import Application from "flarum/Application";

export default function () {
  // Refresh page if session is expired
  override(Application.prototype, 'request', function (request, options) {
    options.errorHandler = (error) => {
      if (error.response.errors[0].status === '440' &&
        error.response.errors[0].code === 'session_expired') {
        location.reload();
      }
      throw error;
    };
    return request(options);
  });
}
